import React from "react";
import { Switch } from "react-router-dom";
import { ContentRoute } from "../../../../../_metronic/layout";
// import { PrintLoadingDialog } from "../waves/waves-loading-dialog/PrintLoadingDialog";
import { PharmaReceivingCard } from "./PharmaReceivingCard";
import { PharmaReceivingUIProvider } from "./PharmaReceivingUIContext";
                  
export function PharmaReceivingPage({ history }) {


  const pharmaReceivingUIEvents = {

    openEditOrderPage: (id) => {
      history.push(`/logistica/ordenes/${id}/edit`);
    }, 
    
  };

  return (
    <PharmaReceivingUIProvider pharmaReceivingUIEvents={pharmaReceivingUIEvents}>

      {/* <PrintLoadingDialog/> */}
      {/* <WavesLoadingDialog /> */}
      <Switch>
          {/* <ContentRoute path="/logistica/entregas/:id/edit" component={EditDeliveryPage} />
          <ContentRoute path="/logistica/entregas/nuevo" component={NewDeliveryPage} /> */}
          <ContentRoute component={PharmaReceivingCard} />
      </Switch>
      {/* <WavesCard /> */}

    </PharmaReceivingUIProvider>
  )
}